// extracted by mini-css-extract-plugin
export var audioPlayer = "_ri-0";